import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReferenceLibraryService } from '../../../../services/referenceLibrary.service';
import { ReferenceLibrary } from 'src/app/data/models/referenceLibrary.model';
import * as errorUtils from "src/app/modules/utility/global-utils";
import { CacheCountryService } from 'src/app/services/cacheCountries.service';
import { ApiServicesService } from '../../../beneficiary/services/api-services.service';
import { select, Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { getStepDetails, getSubTaskDetails } from '../../store/selectors/sub-task-details.selectors';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TaskStep } from 'src/app/data/models/task-step.model';
import { updatei140StepStatus, updateStepStatusToInitialState } from '../../store/actions/step-status-update.actions';
import { getStepStatusUpdate } from '../../store/selectors/step-status-update.selectors';
import { loadSubTaskDetails } from '../../store/actions/sub-task-details.actions';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { first } from 'rxjs/internal/operators/first';
import { StepStatusUpdatePayload } from '../../utility/services/stepStatusUpdate.service';
import { ImagilityBaseResponse } from '../../../../data/models/response.model';
import { PetitionBuilderService } from 'src/app/services/petition-builder.service';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { DirtyFormGuard } from 'src/app/dirty-form.guard';
import { combineLatest } from 'rxjs';
import { JobDescriptionService } from 'src/app/modules/l1-visa/components/job-description/job-description.service';
import { AppServicesLibraryService } from 'app-services-library';
import { SubTaskDetails } from 'app-models';
import moment from 'moment';
import { PrimaryData } from 'app-models';

@Component({
  selector: 'app-job-description',
  templateUrl: './job-description.component.html',
  styleUrls: ['./job-description.component.scss']
})
export class JobDescriptionComponent implements OnInit {

  inputData: PrimaryData;
  jobDescriptionForm: FormGroup;
  jobDescription: any;
  listDuties: [];
  subJobDuty: {
    id: number,
    duty: string,
    name: string,
  }[];
  disabledControls: boolean;
  wageUnitType: ReferenceLibrary[];
  countryList: [];
  stateList: [];
  typeOfButton: string; // This is required for status update button
  stepDetails: TaskStep;
  titleSoc: string;

  observableSubscription$ = new Subject();
  formChangesSubscription: any;
  guardSubscription: any;
  task: SubTaskDetails;
  showLaborInfo: boolean;
  showNext: boolean = false;
  showPrev: boolean = false;

  constructor(
    private jobDescriptionBuilder: FormBuilder,
    private store: Store<any>,
    private pbService: PetitionBuilderService,
    public dynamicDialogRef: DynamicDialogRef,
    public dynamicDialogConfig: DynamicDialogConfig,
    private referenceLibraryService: ReferenceLibraryService,
    private cacheCountyService: CacheCountryService,
    private guard: DirtyFormGuard,
    private apiServiceState: ApiServicesService,
    private toastr: ToastrService,
    private stepStatusUpdatePayloadCostruction: StepStatusUpdatePayload,
    private jobDescriptionService: JobDescriptionService,
    private appServicesLibraryService: AppServicesLibraryService
    ) {
    this.countryList = [];
    this.stateList = [];
    this.disabledControls = false;
    this.showLaborInfo = false;
    this.inputData = this.dynamicDialogConfig.data;
    this.showNext = this.inputData?.showNext; 
    this.showPrev = this.inputData?.showPrev;
  }

  ngOnInit() {
    // Selector for step status update
    this.store.pipe(select(getStepStatusUpdate)).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
      if (response && response.status === 200) {
        this.toastr.success(response.message, 'Success');
        this.store.dispatch(loadSubTaskDetails({ taskId: this.stepDetails.taskId }));
      }
    });
     // Get Sub task Details
     this.store.pipe(select(getSubTaskDetails)).pipe(takeUntil(this.observableSubscription$)).subscribe((data: any) => {
      this.task = data;
      this.showLaborInfo = this.task?.taskTypeDetails?.immClassificationCode ? ['EB2ADVDEG','EB2EXCPABLTY','EB2NATINTWVR','EB3SKLWRKR','EB3PROF','EB3UNSKLWRKR','EB1EXEC'].includes(this.task?.taskTypeDetails?.immClassificationCode):false;
    //  console.log("this.task",this.task);
    });

    this.jobDescriptionForm = this.jobDescriptionBuilder.group({
      id: [null],
      jobTitle: [null, Validators.required],
      socCode: [null, Validators.required],
      socTitle: [null],
      duties: this.jobDescriptionBuilder.array([]),
      address: this.jobDescriptionBuilder.group({
        id: [null],
        addressLine1: [null, Validators.required],
        addressLine2: [null],
        countryCode: [null, Validators.required],
        stateProvinceCode: [null],
        stateProvinceName: [null],
        city: [null, Validators.required],
        postCode: [null, Validators.required],
        addressTypeCode: 'WORK',
      }),
      wagesFrom: [null, [Validators.required, Validators.pattern(/^[1-9]\d*(\.\d+)?$/)]],
      wagesTo: [null, [Validators.pattern(/^[1-9]\d*(\.\d+)?$/)]],
      wageTypeCode: [null, Validators.required],
      wageTypeName: [null],
      thisFulltime: [true],
      workingHoursPerWeek: [null],
      thisPermanentPos: [true],
      thisNewPos: [true],
      otherJobPosition: [null],
      selectedRaiobtn: [0],
      jobRole: [null],
      selectedCategory: [null],
      jobRoleJD: [null],
      laborCertDOLCaseNumber:[null],
      laborCertDOLFilingDate:[null],
      laborCertExpDate:[null]
    });
    this.getCountries();
    this.getWageUnitType();
    this.updateFormControls();
    // Get Specific step details by passing step code
    this.store.pipe(select(getStepDetails, { id: this.dynamicDialogConfig.data.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data: TaskStep) => {
      this.getJobDescription();
      this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
      this.stepDetails = data;
      this.toggleControlsStatus();
    });
  }

  ngAfterViewInit() {
    this.formChangesSubscription = this.jobDescriptionForm.valueChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(() => {
      if (this.jobDescriptionForm.dirty) {
        this.store.dispatch(new MarkDirtyFormAction({
          dirty: true
        }));
      } else {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
      }
    });
  }

  buildDutyList(item) {
    const subJobDuty = [];
    if (item.subJobDuty && item.subJobDuty.length > 0) {
      item.subJobDuty.forEach(element => {
        subJobDuty.push(this.buildSubDutyList(element));
      });
    } else if (item.subduty && item.subduty.length > 0) {
      item.subduty.forEach(element => {
        subJobDuty.push(this.buildSubDutyList(element));
      });
    }
    return this.jobDescriptionBuilder.group({
      name: item.name || item.duty,
      subJobDuty: this.jobDescriptionBuilder.array(subJobDuty)
    });
  }

  buildSubDutyList(item) {
    return this.jobDescriptionBuilder.group({
      name: item.name || item.duty
    });
  }

  handleAddUpdateDuty({ type, data, dutyIndex }) {
    if (type === 'ADD') {
      // If type is ADD then append the job duties to exisiting one
      (this.jobDescriptionForm.controls['duties'] as FormArray).push(this.buildDutyList(data));
    }
    if (type === 'UPDATE') {
      // If type is UPDATE then update the job duties
      (this.jobDescriptionForm.controls['duties'] as FormArray).setControl(dutyIndex, this.buildDutyList(data));
    }
  }

  getJobDescription() {
    this.pbService.getJobDescription(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.subTaskId, this.dynamicDialogConfig.data.i140CaseId).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      this.dynamicDialogConfig.data['jsonInput'] = {jobCategory: response?.jobCategory,jobRole: response?.jobRole};
      this.loadFormValues(response);
    });
  }

  alldutiesDelete() {
    (this.jobDescriptionForm.controls['duties'] as FormArray).clear();
  }


  // Load job Desc form with values
  loadFormValues(response) {
    this.jobDescriptionForm.reset({
      ...response,
      selectedRaiobtn: 0,
      jobRoleJD: response  && response.jobRole ? response.jobRole : null,
      laborCertDOLFilingDate:response && response.laborCertDOLFilingDate ? new Date(response.laborCertDOLFilingDate):null,
      laborCertExpDate:response && response.laborCertExpDate ? new Date(response.laborCertExpDate):null,
    });
    this.handleCountryChange(response.address.countryCode);
    this.loadDuties(response.duties);
  }

  loadDuties(list) {
    (this.jobDescriptionForm.controls['duties'] as FormArray).clear();
    list.forEach(element => {
      (this.jobDescriptionForm.controls['duties'] as FormArray).push(this.buildDutyList(element));
    });
  }

  getCountries() {
    this.cacheCountyService.getCachedCountryList().pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
      if (data.listCountries.length > 0) {
        this.countryList = data.listCountries;
      }
    });
  }

  getWageUnitType() {
    this.referenceLibraryService.getReferenceDataWithoutAuthentication('PAYTYP').pipe(takeUntil(this.observableSubscription$)).subscribe((response: ReferenceLibrary[]) => {
      this.wageUnitType = response;
    });
  }

  handleDataChange(event: any,) {
    if (!event.checked) {
      this.jobDescriptionForm.get('workingHoursPerWeek').reset();
    }
  }

  handleDutyDelete(i: number) {
    (this.jobDescriptionForm.controls['duties'] as FormArray).removeAt(i);
    //this.postJobDescription();
  }

  handleDeleteAllDuties() {
    (this.jobDescriptionForm.controls['duties'] as FormArray).clear();
    this.alldutiesDelete();
    //  this.postJobDescription();
  }

  handleSubDutyDelete({ dutyIndex, subDutyIndex }) {
    ((this.jobDescriptionForm.controls['duties'] as FormArray).controls[dutyIndex] as FormArray).controls['subJobDuty'].removeAt(subDutyIndex);
    // this.postJobDescription();
  }

  updateFormControls() {
    this.jobDescriptionForm.get('thisFulltime').valueChanges.pipe(takeUntil(this.observableSubscription$)).subscribe((value) => {
      if (value) {
        this.jobDescriptionForm.get('workingHoursPerWeek').clearValidators();
      } else {
        this.jobDescriptionForm.get('workingHoursPerWeek').setValidators(Validators.required);
      }
      this.jobDescriptionForm.get('workingHoursPerWeek').reset();
      this.jobDescriptionForm.get('workingHoursPerWeek').updateValueAndValidity();
    });
  }

  postJobDescription() {
    const { jobRoleJD, selectedRaiobtn, ...payload } = {
      ...this.jobDescriptionForm.value,
      selectedRaiobtn: this.jobDescriptionForm.value.selectedRaiobtn,
      jobRoleJD: this.jobDescriptionForm.value.jobRoleJD
    };
    payload['jobRole'] = jobRoleJD;
    const APIs = [
      this.pbService.postJobDescription(payload, this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.subTaskId, this.dynamicDialogConfig.data.i140CaseId)
    ];
    if (selectedRaiobtn === 1) {
      const selectJobRole = JSON.parse(sessionStorage.getItem('selectedJobRole'));
      const jobDuty = this.jobDescriptionForm.value.duties ?
        this.jobDescriptionForm.value.duties.map(x => {
          return {
            dutyId: 0,
            duty: x.name,
            subduty: x.subJobDuty && x.subJobDuty.length > 0 ?
              x.subJobDuty.map(y => {
                return {
                  dutyId: 0,
                  duty: y.name,
                };
              }) : []
          };
        }) : [];
      const jobRoleConst = {
        id: selectJobRole.id,
        jobDuty,
        jobRoleName: selectJobRole.jobTitle === 'Other' ? this.jobDescriptionForm.value.otherJobPosition : selectJobRole.jobTitle,
        requestFlag: 'updatemasterdata'
      };
      APIs.push(this.jobDescriptionService.saveJobRole(this.dynamicDialogConfig.data.companyId,
        this.jobDescriptionForm.value.selectedCategory.id, jobRoleConst));
    }
    combineLatest(APIs)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: any[]) => {
        if (response[0] && response[0].status === 200) {
          this.loadFormValues(response[0].data);
          this.toastr.success(response[0].message, 'Success');
          if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
            this.updateStepStatus('INPROGRESS');
          }
        }
        if (selectedRaiobtn === 1 && response[1] && response[1].status === 200) {
          this.toastr.success(response[1]['message'], 'Success');
        }
      });
  }

  getSocCode() {
    this.titleSoc = '';
    this.pbService.ongetSOCCode(this.jobDescriptionForm.value.socCode).
      subscribe(
        data => {
          if (data === null) {
            this.titleSoc = 'No SOC occupation title found';
            this.jobDescriptionForm.patchValue({
              socTitle: null,
            });
          } else {
            // this.socTitle = data.title;
            this.titleSoc = '';
            this.jobDescriptionForm.patchValue({
              socTitle: data.title,
            });
          }
        });
  }


  updateStepStatus(status) {
    this.store.dispatch(updatei140StepStatus({ payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status), subTaskId: this.stepDetails.taskId, actionCode: this.stepDetails.stepActionList[0].layoutCode }));
  }


  handleCountryChange(countryCode: string) {
    this.apiServiceState.getStates(countryCode).pipe(takeUntil(this.observableSubscription$)).subscribe((states: []) => {
      this.stateList = states;
      //this.changeDetector.markForCheck();
    });
  }
  //Toggle controls status based on step status
  toggleControlsStatus() {
    this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
    // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  handleClose() {
    this.guardSubscription = this.guard.canDeactivate().pipe(first()).subscribe((response: boolean) => {
      if (response) {
        this.dynamicDialogRef.close();
      }
      else {
        return false;
      }
    });
  }

  handleCancel() {
    this.getJobDescription();
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    // Update the Step Status state to empty state
    this.store.dispatch(updateStepStatusToInitialState());
  }

}
